export const EXPORT_MULTIPLE_CLIENT_REPORT_PDF_MESSAGES = {
  NOT_FOUND: 'No report was found',
};


// WEBPACK FOOTER //
// ./src/features/reports/constants/exportMultipleClientReportPdfContants.js